<template>
	<div class="indeterminate-progress-bar">
		<div class="indeterminate-progress-bar__progress"></div>
	</div>
</template>

<style scoped>
	.indeterminate-progress-bar {
		--fade-in-delay: var(--progress-bar-fade-in-delay, 0s);
		background-color: var(--color-grey-50);
		height: 4px;
		margin-bottom: -4px;
		position: relative;
		z-index: 2;
		overflow: hidden;
		opacity: 0;
		animation: indeterminate-progress-bar-fade-in .2s ease-out;
		animation-delay: var(--fade-in-delay);
		animation-fill-mode: forwards;
	}

	.indeterminate-progress-bar__progress {
		background-color: var(--color-primary);
		position: absolute;
		bottom: 0;
		top: 0;
		width: 50%;
		animation-duration: 2s;
		animation-delay: var(--fade-in-delay);
		animation-iteration-count: infinite;
		animation-name: indeterminate-progress-bar;
	}

	@keyframes indeterminate-progress-bar-fade-in {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	@keyframes indeterminate-progress-bar {
		from {
			left: -50%;
		}
		to {
			left: 100%;
		}
	}
</style>
